import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/services';
import { Router } from '@angular/router';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChildren('itemElement') menuItems: QueryList<ElementRef>;
  menus: any[] = [];
  searchText: string = ''; // Texto de búsqueda
  objAuthData: any;

  flattenedMenus: any[] = [];
  currentIndex: number = -1;

  constructor(
    public modalRef: BsModalRef,
    private authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.objAuthData = this.authService.getAuthData();
    this.menus = this.objAuthData.menu;
  }

  ngAfterViewInit(): void {
    // Enfocar el input después de que la vista se haya inicializado
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 0);
  }

  // Método para filtrar menús
getfilteredMenus() {
  if (!this.searchText) {
    this.menus = this.objAuthData.menu;
    this.flattenedMenus = [];
    this.currentIndex = -1;
    return;
  }

  this.menus = this.objAuthData.menu
    .map(menu => {
      const filteredHijos = menu.hijos
        ? menu.hijos.filter(submenu =>
            submenu.nombre.toLowerCase().includes(this.searchText.toLowerCase()) ||
            submenu.ruta.toLowerCase().includes(this.searchText.toLowerCase())
          )
        : [];

      if (
        menu.nombre.toLowerCase().includes(this.searchText.toLowerCase()) ||
        menu.ruta.toLowerCase().includes(this.searchText.toLowerCase()) ||
        filteredHijos.length > 0
      ) {
        return { ...menu, hijos: filteredHijos };
      }

      return null;
    })
    .filter(menu => menu !== null);

  // Aplanar la lista de menús y submenús
  this.flattenedMenus = [];
  this.menus.forEach(menu => {
    this.flattenedMenus.push({ item: menu, type: 'menu', level: 0 });
    if (menu.hijos && menu.hijos.length > 0) {
      menu.hijos.forEach(submenu => {
        this.flattenedMenus.push({ item: submenu, type: 'submenu', level: 1 });
      });
    }
  });

  // Reiniciar el índice de selección
  this.currentIndex = -1;
}


  // Capturar eventos de teclado
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.moveSelection(1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.moveSelection(-1);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.selectMenuItem();
    }
  }

  // Mover la selección
  moveSelection(direction: number) {
    if (this.flattenedMenus.length === 0) {
      return;
    }

    this.currentIndex += direction;

    if (this.currentIndex < 0) {
      this.currentIndex = this.flattenedMenus.length - 1;
    } else if (this.currentIndex >= this.flattenedMenus.length) {
      this.currentIndex = 0;
    }

    // Ajustar el scroll para mantener el elemento visible
    this.scrollToCurrentItem();
  }



  // Desplazar el scroll al elemento seleccionado
  scrollToCurrentItem() {
    if (
      this.currentIndex >= 0 &&
      this.currentIndex < this.menuItems.length
    ) {
      const itemsArray = this.menuItems.toArray();
      const currentItemElement = itemsArray[this.currentIndex].nativeElement;

      currentItemElement.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      });
    }
  }

selectMenuItem() {
  if (this.currentIndex >= 0 && this.currentIndex < this.flattenedMenus.length) {
    const selectedItem = this.flattenedMenus[this.currentIndex];
    this.navigateTo(selectedItem.item.ruta);
  }
}


  navigateTo(route: string) {
    this.modalRef.hide();
    this.router.navigate([route]);
  }
}
